<template src="./Negociacao.html"></template>

<script>
  import acordo from "@/services/acordo";
  import devedores from "@/services/devedores";
  import usuario from "@/services/usuario"; 
  import telefonedeve from "@/services/telefonedeve";
  import { mapMutations } from "vuex";
  import {VMoney} from 'v-money';
  import moment from "moment";

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }
  export default {
    name: 'Negociacao',
    data () {
      return {
        valid: true,
        dialogConfirmation:false,
        menu2: false,
        date2: new Date().toISOString().substr(0, 10),
        dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
        menu3: false,
        date3: new Date().toISOString().substr(0, 10),
        dateFormatted3: this.formatDate(new Date().toISOString().substr(0, 10)),
        mask: '(##) #####-####',
        modal2: false,
        user: {},
        message: "",
        dialogError: false,
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2
        },
        dialogParcela: false,
        parcelas: [],
        headersParcelas: [{
          text: 'Numero',
          value: 'numero'
        },
        {
          text: 'Vencimento',
          value: 'vencimento'
        },
        {
          text: 'Valor',
          value: 'valor'
        }
      ],
      }
    },
    async mounted () {
      this.user = await usuario.getUsuario(this.$store.getters.user._id);
      this.$forceUpdate();
    },
    computed: {
      computedDateFormatted2 () {
        return this.formatDate(this.date2)
      },
      computedDateFormatted3 () {
        return this.formatDate(this.date3)
      },
      devedor() {
        return this.$store.getters["devedor"];
      },
      acordo() {
        return this.$store.getters["acordo"];
      },
      loading() {
        return this.$store.getters["loading"];
      },
    },
    watch: {
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.acordo.dtVencimento = this.date2;
      },
      date3 (val) {
        this.dateFormatted3 = this.formatDate(this.date3)
        this.acordo.dtVencimentoParcela = this.date3;
      },
      // acordo (val) {
      //   this.$refs.ValorAcordo.$el.getElementsByTagName('input')[0].value = this.acordo.ValorAcordo;
      //   this.$refs.ValorEntrada.$el.getElementsByTagName('input')[0].value = 0;
      // },
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      allowedDatesParcela (date) {
        let val = moment().add(45, 'days');
        return moment(date) <= val;
      },
      allowedDates (date) {
        let val = moment().add(15, 'days');
        return moment(date) <= val;
      },
      async salvar (parcela) {
        if (this.$refs.form.validate()) {
          if (!parcela) {
            // let valorAcordo = this.acordo.ValorAcordo.replace('.', '').replace('.', '').replace('.', '');
            // valorAcordo = valorAcordo.replace(',', '.');
            let valorAcordo = Number(this.acordo.ValorAcordo);
            
            let vencimento = this.acordo.dtVencimento;
            let parcelas = [];
            let entrada = 0;
            if (this.acordo.ValorEntrada) {

              // entrada = this.acordo.ValorEntrada.replace('.', '').replace('.', '').replace('.', '');
              // entrada = entrada.replace(',', '.');
               entrada = Number(this.acordo.ValorEntrada);

              if (entrada) {
                parcelas.push({"numero": 1, "valor": entrada, "vencimento": vencimento });
              }
            }

            
            let vencimentoParcela = this.acordo.dtVencimentoParcela;
            for (let index = 0; index < this.acordo.nrParcela; index++) {
              let valor = 0;
              if (index+1 != this.acordo.nrParcela) {
                valor = ((valorAcordo-entrada)/this.acordo.nrParcela);
              } else {
                valor = Number(valorAcordo) - Number(parcelas.map((item) => {return item.valor}).reduce((prev, next) => {return (prev + next)}));
              }
              vencimentoParcela = new Date(Date.parse(vencimentoParcela));
              if (index == 0) {
                parcelas.push({"numero": (parcelas.length+1), "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) })
              } else {
                parcelas.push({"numero": (parcelas.length+1), "valor": valor, "vencimento": new Date(vencimentoParcela.setMonth(vencimentoParcela.getMonth()+1)).toISOString().substr(0, 10) })
              }
            }
            
            this.acordo.parcelas = parcelas;
            this.dialogParcela = true;
            return;
          } else {
            this.setLoading(true);
            if (!this.acordo.telefone) {
              this.setError('Telefone de Fechamento do Acordo deve ser informado!');
              this.setLoading(false);
              return;
            }
            let telefone = {
              devedor: this.devedor._id,
              telefone: this.acordo.telefone,
              hot: true
            }
            await telefonedeve.save(telefone);


            let ValorAcordo = this.acordo.ValorAcordo;//.replace('.', '').replace('.', '').replace('.', '');
            //ValorAcordo = ValorAcordo.replace(',', '.');
            if (Number(ValorAcordo) != 
                Number(this.acordo.parcelas.map((item) => {
                       return Number(item.valor) 
                     })
                     .reduce((prev, next) => {return (prev + next)}))) {

              this.message = "O Valor das parcelas (" + this.acordo.parcelas.map((item) => {
                       return Number(item.valor) 
                     })
                     .reduce((prev, next) => {return (prev + next)}) + ") não é igual ao valor do Acordo (" + this.acordo.ValorAcordo + ")";
              this.dialogError = true;
              return;
            }
            this.acordo.devedor = this.devedor._id;
            this.acordo.cliente = this.acordo.idcliente._id;
            this.acordo.user = this.user._id;
            this.acordo.StatusAcordo = '2';
            await acordo.save(this.acordo);
            this.setDevedor(await devedores.getDevedoreId(this.acordo.devedor));
            if (this.devedor.dividas) {
              this.setAcordo(this.devedor.dividas[0].acordo);
            }
            this.dialogParcela = false;
            this.setLoading(false);
            this.$forceUpdate();
          }
        }
      },
      calculaParcelas (parcelas) {
        if (parcelas && parcelas.length>0) {
          return Number(parcelas.map((item) => Number(item.valor?item.valor:0)).reduce((prev, next) => (prev + next)).toFixed(2));
        } else {
          return 0;
        }
      },
      getTipoProduto (tipo) {
        if (!tipo) return '';
        if (tipo == 1) return 'Boleto';
        else if (tipo == 2) return 'Cheque';
        else if (tipo == 3) return 'Nota';
        else if (tipo == 4) return 'Nota Fiscal';
        else if (tipo == 5) return 'Promissoria';
      },
      getDiasAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24);
          return result;
        }
        return null;
        
      },
      getMesesAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30);
          return result;
        }
        return null;
      },
      getAnosAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30/12);
          return result;
        }
        return null;
      },
      ...mapMutations({
        setDevedor: "setDevedor",
        setAcordo: "setAcordo",
        setLoading: "setLoading",
        setError: "setError"
      })
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  .col {
    margin: 0px !important;
    padding: 0px !important; 
  }
  .label-negociacao {
    line-height: 70px; 
    text-align: right; 
    margin-right: 20px !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/cobranca/Negociacao.vue